export default __webpack_public_path__ + "static/media/modal12.d7dc393e.jpg";